import React, { FC } from 'react'

interface Props {
  message: string
}

export const ErrorMessage: FC<Props> = ({ message }) => {
  return <div>{message}</div>
}
